import examAPI from './examAPI';

const EXAM_PREFIX = '/api/employee-attendance/hr/exams';
const MARKS_PREFIX = '/api/marks';
const pg = (params = {}) => ({ ...params, portal: 'postgraduate' });

const pgTeacherSheetAPI = {
  baseURL: examAPI.baseURL,
  getFaculties(token) {
    return examAPI.request(`${EXAM_PREFIX}/lookups/faculties`, pg(), token, { suppressUnauthorized: true });
  },
  getDepartments(facultyId, token) {
    return examAPI.request(`${EXAM_PREFIX}/lookups/departments`, pg({ faculty_id: facultyId || undefined }), token, { suppressUnauthorized: true });
  },
  getBatches(departmentId, token, extra = {}) {
    return examAPI.request(`${EXAM_PREFIX}/lookups/batches`, pg({ department_id: departmentId || undefined, ...extra }), token, { suppressUnauthorized: true });
  },
  getSubjects(params, token) {
    return examAPI.request(`${EXAM_PREFIX}/lookups/subjects`, pg(params), token, { suppressUnauthorized: true });
  },
  getSemesters(token) {
    return examAPI.request(`${EXAM_PREFIX}/lookups/semesters`, pg(), token, { suppressUnauthorized: true });
  },
  previewStudents(params, token) {
    return examAPI.request(`${EXAM_PREFIX}/entries/preview-students`, pg(params), token, { suppressUnauthorized: true });
  },
  getMarksStudentList(params, token) {
    return examAPI.request(`${MARKS_PREFIX}/student-list`, pg(params), token, { suppressUnauthorized: true });
  },
};

export default pgTeacherSheetAPI;
